import cleanUpResponse from '@/util/cleanUpResponse';

export default async function ReassignAssessment(formData) {
  const response = await $.soap({
    body: {
      ReassignAssessment: {
        $xmlns: 'http://dla.mil/ems/bpm/assessment',
        AssessmentId: formData.assessmentId,
        CRSId: formData.crsId
      }
    }
  });

  cleanUpResponse(response);
  return response;
}